module.exports = __webpack_public_path__ + "fonts/Nunito-Regular.65bb0a15.ttf";